import React, { FC } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

/**
 * Component for showing info message on hover and tap (mobile-safe)
 */
export const FxInfoTooltip: FC<TooltipProps> = (props) => {
  const {
    className,
    enterTouchDelay = 0,
    leaveTouchDelay = 3000,
    disableFocusListener = false,
    disableTouchListener = false,
    disableHoverListener = false,
    ...restProps
  } = props;

  return (
    <Tooltip
      {...restProps}
      arrow
      classes={{ popper: `${className || ''} fx-info-tooltip` }}
      enterTouchDelay={enterTouchDelay}
      leaveTouchDelay={leaveTouchDelay}
      disableFocusListener={disableFocusListener}
      disableTouchListener={disableTouchListener}
      disableHoverListener={disableHoverListener}
    >
      {props.children}
    </Tooltip>
  );
};
